import api from "./api";

const qs = p => {
  const u = new URLSearchParams();
  Object.entries(p).forEach(([k,v]) => {
    if (v !== "" && v !== undefined && v !== null) u.set(k, v);
  });
  return u.toString();
};

const svc = {
  fila:        (p={}) => api("GET",  `/pagamentos/fila?${qs(p)}`),
  calendario:  (p={}) => api("GET",  `/pagamentos/calendario?${qs(p)}`),
  pagarLote:   (data) => api("POST", "/pagamentos/lote", data),
  agendar:     (data) => api("POST", "/pagamentos/agendar", data),
  cancelarAgendamento: (ids) => api("POST", "/pagamentos/cancelar-agendamento", { ids }),
};

export default svc;
